import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import {
  FormInput,
  FormDateSelector,
  FormSelector,
} from "../FormElements/index";
import { Button } from "../Elements";
import AmountRange from "../AmountRange";
import { filtersSchema } from "../../../common/validators/paymentLinksFilterSchema";
import { useDispatch, useSelector } from "react-redux";
import { clearOrderReportCustomer, getOrderReports } from "../../../store/slices/orderReportSlice";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import { sendOptions } from "../../../constants/options/sendOptions";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import FormObserver from "../FormElements/FormObserver";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import useGetCustomerName from "../../../hooks/useGetCustomerName";
import { orderResource } from "../../../constants/options/orderResource";
import useFetchCityDistrict from "../../../hooks/useFetchCityDistrict";
import { installmentType } from "../../../constants/options/installmentType";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import { buttonTexts } from "../../../constants/texts/buttonTexts";
import useGetUserName from "../../../hooks/useGetUserName";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { errorMessages } from "../../../constants/messages/errorMessages";
import { getUserIdentity } from "../../../common/helpers/authorizationHelper";
import { getParentAndChildUserHelper } from "../../../common/helpers/getParentAndChildUserHelper";

const paymentStatusOptions = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    value: 1,
    label: "Başarılı",
  },
  {
    value: 4,
    label: "İptal/İade",
  },
  {
    value: 2,
    label: "Başarısız",
  },
  {
    value: 3,
    label: "Beklemede",
  },
];

const erpSyncOptions = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    value: 1,
    label: "Aktarılanlar",
  },
  {
    value: 2,
    label: "Aktarılmayan",
  },
];

const isTestOptions = [
  {
    value: false,
    label: "Canlı Ortam"
  },
  {
    value: true,
    label: "Test Ortam"
  }
]

const Filters = React.forwardRef(({ isOpen, setFiltersIsOpen, onShowDetailChange }, ref) => {
  const initialValues = {
    dateRange: {
      startDate: null,
      endDate: null,
    },
    customerCode: "",
    sendTypeId: 0,
    paymentStatusId: 0,
    amountRange: {
      start: 0,
      end: 0,
    },
    linkDateRange: {
      startDate: null,
      endDate: null,
    },
    erpSyncType: 0,
    bankId: 0,
    customerId: 0,
    cityId: 0,
    // ipAddress: "",
    // customerEmail: "",
    orderResource: 0,
    cardFirstPart: "",
    cardLastPart: "",
    orderCode: "",
    // bankRefNo: "",
    installmentType: 0,
    taxCode: "",
    authCode: "",
    createUserId: ["BAYİ/MÜŞTERİ", "ALTBAYİ", "MÜŞTERİ TEMSİLCİSİ"].includes(getUserIdentity())
      ? parseInt(localStorage.getItem("_us_d") || "0", 10)
      : null,
    currencyId: 0,
    showDetail: false,
    isTest: false,
    invoiceNumber: "",
    parentUserId: 0,
  };

  useImperativeHandle(ref, () => ({

    submitform() {
      submitform();
    }
  }));

  const { firmInformations } = useRecoilValue(tenantState);

  const { selectedCustomer } = useSelector((state) => state.orderReport);
  const currencySelectList = useSelector((state) => state.firmCurrencyList.currencyListForSelect);
  const formref = useRef();
  const dateRangeRef = useRef();
  const linkDateRangeRef = useRef();
  const customerCodeInputRef = useRef();
  const isInitialRequest = useRef(true);
  const isMountedEffect = useRef(false);

  const [formValues, setFormValues] = useState(initialValues);
  const [posList, setPosList] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [isDealer, setIsDealer] = useState(false);
  const [parentUsers, setParentUsers] = useState([]);
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [loadingParentUser, setLoadingParentUser] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);

  const dispatch = useDispatch();

  useLayoutEffect(() => {

    selectPos();

  }, []);

  useEffect(() => {
    if (selectedCustomer.code) {
      customerCodeInputRef.current.setValue(selectedCustomer.code);

      dispatch(clearOrderReportCustomer());
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (onShowDetailChange) {
      onShowDetailChange(formValues.showDetail);
    }
  }, [formValues.showDetail]);

  useEffect(() => {
    handleUserIdentity();
    getParentAndChildUserHelper(setParentUsers, setLoadingParentUser);
  }, []);

  useEffect(() => {
    if (!isMountedEffect.current) {
      isMountedEffect.current = true;
      selectOrderList();
    }
  }, []);

  useEffect(() => {
    if (isDealer) {
      formref.current.setFieldValue(
        "createUserId",
        parseInt(localStorage.getItem("_us_d") || "0", 10)
      );
    }
  }, [formValues]);

  useGetCustomerName(setCustomerOptions, setLoadingCustomer);
  useFetchCityDistrict(formValues.cityId, setCityOptions);
  useGetUserName(setUserOptions, setLoadingUser);

  const selectPos = async () => {

    const data = await commonNetwork.get("/virtualpos");
    var poslist = [];
    if (data.isSuccess) {
      var res = data.data.data;
      poslist.push({
        value: 0,
        label: "Tümü",
      });
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        poslist.push({
          value: element.vpid,
          label: element.vpdisplayname ? element.vpdisplayname : element.bankname,
        });
      }
      setPosList(poslist);

    } else {
      toast.error(data.errorMessage);
    }
  }

  const selectOrderList = () => {
    if (formref && formref.current) {
      formref.current.submitForm();
    }
  }

  function submitform() {
    formref.current.submitForm();
  }

  const onSubmit = async (values, actions) => {
    if (parseFloat(formValues.amountRange.start) > parseFloat(formValues.amountRange.end) && formValues.amountRange.end !== 0) {
      toast.error(errorMessages.lowEndAmountRange);
    } else {
      var start = values.dateRange.startDate;
      var end = values.dateRange.endDate;
      var linkstart = values.linkDateRange.startDate;
      var linkend = values.linkDateRange.endDate;

      var startDate = "";
      var endDate = "";
      if (start) {
        startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
      }
      if (end) {
        endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
      }

      var linkstartDate = "";
      var linkendDate = "";
      if (linkstart) {
        linkstartDate = linkstart.getDate() + "/" + (linkstart.getMonth() + 1) + "/" + linkstart.getFullYear();
      }
      if (linkend) {
        linkendDate = linkend.getDate() + "/" + (linkend.getMonth() + 1) + "/" + linkend.getFullYear();
      }

      const parameters = {
        startDate: startDate,
        endDate: endDate,
        customerName: values.customerCode,
        startAmount: values.amountRange?.start || "0",
        endAmount: values.amountRange?.end || "0",
        sendType: values.sendTypeId,
        paymentStatus: values.paymentStatusId || 0,
        linkStartDate: linkstartDate,
        linkEndDate: linkendDate,
        erpSyncType: values.erpSyncType,
        bankId: values.bankId,
        customerId: values.customerId,
        cityId: values.cityId,
        // ipAddress: values.ipAddress,
        // customerEmail: values.customerEmail,
        orderResource: values.orderResource,
        cardFirstPart: values.cardFirstPart,
        cardLastPart: values.cardLastPart,
        orderCode: values.orderCode,
        // bankRefNo: values.bankRefNo,
        installmentType: values.installmentType || 0,
        taxCode: values.taxCode,
        authCode: values.authCode,
        createUserId: isDealer ? localStorage.getItem("_us_d") : values.createUserId,
        currencyId: values.currencyId,
        isTest: values.isTest,
        invoiceNumber: values.invoiceNumber || "",
        parentUserId: values.parentUserId
      };
      dispatch(getOrderReports({ parameters }));

      if (isInitialRequest.current) {
        isInitialRequest.current = false;
      } else {
        setFiltersIsOpen(false);
      }
    }
  };

  const openCustomerForm = () => {
    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromOrderReport
    }
    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  const clearFilters = () => {
    dispatch(updateIsResetForm(true));
    setTimeout(() => {
      dispatch(updateIsResetForm(false));
    }, 1000);

    formref.current.resetForm();
    submitform();
  };

  const resetDateRanges = (value) => {
    var keys = Object.keys(value);

    if (keys && keys.length > 0) {
      if (keys[0] == "dateRange") {
        dateRangeRef.current.resetForm();
      }
      if (keys[0] == "linkDateRange") {
        linkDateRangeRef.current.resetForm();
      }
    }
  }

  const onUpdate = (value) => {
    setFormValues(Object.assign(formValues, value));
    resetDateRanges(value);
    submitform();
  };

  const handleUserIdentity = () => {
    switch (getUserIdentity()) {
      case "BAYİ/MÜŞTERİ":
      case "ALTBAYİ":
      case "MÜŞTERİ TEMSİLCİSİ":
        setIsDealer(true);
        break;
      default:
        setIsDealer(false);
        break;
    }
  }

  const fields = [
    {
      key: "customerId",
      label: "Alıcı Ünvan / Ad Soyad",
      type: "select",
      options: customerOptions
    },
    { key: "invoiceNumber", label: "Fatura Numarası", type: "text" },
    {
      key: "customerCode",
      label: "Cari Hesap Ünvan / Cari Kod",
      type: "text"
    },
    {
      key: "dateRange",
      label: "Tarih Aralığı",
      type: "object",
      datatype: "daterange"
    },
    {
      key: "taxCode",
      label: "VKN/TCKN",
      type: "text"
    },
    {
      key: "installmentType",
      label: "Ödeme Yöntemi",
      type: "select",
      options: installmentType
    },
    {
      key: "bankId",
      label: "Ödeme Altyapısı",
      type: "select",
      options: posList
    },
    {
      key: "paymentStatusId",
      label: "Ödeme Durumu",
      type: "select",
      options: paymentStatusOptions,
    },
    {
      key: "isTest",
      label: "Ödeme Ortamı",
      type: "select",
      options: isTestOptions,
    },
    {
      key: "sendTypeId",
      label: "Link Gönderim Şekli",
      type: "select",
      options: sendOptions
    },
    {
      key: "linkDateRange",
      label: "Link Gönderim Tarihi",
      type: "object",
      datatype: "daterange"
    },
    {
      key: "orderResource",
      label: "Ödeme Kaynağı",
      type: "select",
      options: orderResource
    },
    {
      key: "orderCode",
      label: "Sipariş Kodu",
      type: "text"
    },
    {
      key: "authCode",
      label: "Onay Kodu",
      type: "text"
    },
    {
      key: "cityId",
      label: "Şehir",
      type: "select",
      options: cityOptions
    },
    {
      key: "amountRange",
      label: "Bakiye Aralığı",
      type: "object",
      datatype: "moneyrange"
    },
    {
      key: "cardFirstPart",
      label: "Kart İlk 4 Hane",
      type: "text"
    },
    {
      key: "cardLastPart",
      label: "Kart Son 4 Hane",
      type: "text"
    },
    {
      key: "parentUserId",
      label: "Bayi",
      type: "select",
      options: parentUsers
    },
    {
      key: "createUserId",
      label: "Ödemeyi Alan Kullanıcı",
      type: "select",
      options: userOptions
    },
    {
      key: "currencyId",
      label: "Para Birimi",
      type: "select",
      options: currencySelectList
    },
    {
      key: "erpSyncType",
      label: "ERP Fiş Durumu",
      type: "select",
      options: erpSyncOptions
    }
  ];

  return (
    <Formik
      innerRef={formref}
      initialValues={initialValues}
      validationSchema={filtersSchema}
      onSubmit={onSubmit}
    >
      {({
        values,
        touched,
        dirty,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
      }) => (
        <Form>
          <FormObserver
            watch={(val) => {
              setFormValues(val);
            }}
          />
          <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`} >
            <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-4 ">

              <div className="flex flex-col justify-start px-0 ">
                <div className="mt-1">
                  <FormSelector
                    options={customerOptions}
                    name="customerId"
                    label="Cari Hesap Seç"
                    value={getSelectedValueFromId(values.customerId, customerOptions)}
                    isSearchable
                    isClearable
                    isLazyFrontend
                    lazyPageSize={50}
                    loading={loadingCustomer}
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="Cari Hesap Ünvan / Cari Kodu"
                    name="customerCode"
                    type="text"
                  />
                </div>
                <div className="mt-2">
                  <FormDateSelector
                    label="Tarih Aralığı"
                    name="dateRange"
                    type="range"
                    nullable={true}
                    ref={dateRangeRef}
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="VKN/TCKN"
                    name="taxCode"
                    mask="99999999999"
                    type="text"
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={installmentType}
                    name="installmentType"
                    placeholder="Tümü"
                    label="Ödeme Yöntemi"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.installmentType}
                    touched={touched.installmentType}
                    defaultValue={values.installmentType}
                    value={getSelectedValueFromId(values.installmentType, installmentType)}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormSelector
                    options={erpSyncOptions}
                    name="erpSyncType"
                    placeholder="Tümü"
                    label="ERP Fiş Durumu"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.erpSyncType}
                    touched={touched.erpSyncType}
                    defaultValue={values.erpSyncType}
                    value={getSelectedValueFromId(values.erpSyncType, erpSyncOptions)}
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={posList}
                    name="bankId"
                    placeholder="Tümü"
                    label="Ödeme Altyapısı"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.bankId}
                    touched={touched.bankId}
                    defaultValue={formValues.bankId}
                    value={getSelectedValueFromId(values.bankId, posList)}
                    isDisabled={isDealer}
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={sendOptions}
                    name="sendTypeId"
                    placeholder="Tümü"
                    label="Link Gönderim Şekli"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.sendTypeId}
                    touched={touched.sendTypeId}
                    defaultValue={values.sendTypeId}
                    value={getSelectedValueFromId(values.sendTypeId, sendOptions)}
                    isClearable
                  />
                </div>
                <div className="mt-2">
                  <FormDateSelector
                    label="Link Gönderim Tarihi "
                    name="linkDateRange"
                    type="range"
                    nullable
                    ref={linkDateRangeRef}
                  />
                </div>
                <div className="mt-3">
                  <FormInput
                    label="Fatura Numarası"
                    name="invoiceNumber"
                    type="text"
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={isTestOptions}
                    name="isTest"
                    label="Ödeme Ortamı"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.isTest}
                    touched={touched.isTest}
                    defaultValue={values.isTest}
                    value={getSelectedValueFromId(values.isTest, isTestOptions)}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0 ">
                <div className="mt-1">
                  <FormSelector
                    options={paymentStatusOptions}
                    name="paymentStatusId"
                    placeholder="Tümü"
                    label="Ödeme Durumu"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.paymentStatusId}
                    touched={touched.paymentStatusId}
                    defaultValue={values.paymentStatusId}
                    value={getSelectedValueFromId(values.paymentStatusId, paymentStatusOptions)}
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={orderResource}
                    name="orderResource"
                    placeholder="Tümü"
                    label="Ödeme Kaynağı"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.orderResource}
                    touched={touched.orderResource}
                    defaultValue={values.orderResource}
                    value={getSelectedValueFromId(values.orderResource, orderResource)}
                    isClearable
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="Sipariş Kodu"
                    name="orderCode"
                    type="text"
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="Onay Kodu"
                    name="authCode"
                    type="text"
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={cityOptions}
                    name="cityId"
                    placeholder="Tümü"
                    label="Şehir"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.cityId}
                    touched={touched.cityId}
                    defaultValue={values.cityId}
                    value={getSelectedValueFromId(values.cityId, cityOptions)}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <AmountRange
                    label="Bakiye Aralığı"
                    name="amountRange"
                    type="text"
                  />
                </div>
                <div className="flex flex-row space-x-2 mt-2">
                  <div className="flex-grow">
                    <FormInput
                      label="Kart İlk 4 Hane"
                      name="cardFirstPart"
                      type="text"
                      mask="9999"
                    />
                  </div>
                  <div className="flex-grow">
                    <FormInput
                      label="Kart Son 4 Hane"
                      name="cardLastPart"
                      type="text"
                      mask="9999"
                    />
                  </div>
                </div>
                <div className="mt-2">
                  {["ADMIN"].includes(getUserIdentity()) ?
                    <FormSelector
                      options={parentUsers}
                      label="Bayi"
                      name="parentUserId"
                      type="select"
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      error={errors.parentUserId}
                      touched={touched.parentUserId}
                      defaultValue={values.parentUserId}
                      value={getSelectedValueFromId(values.parentUserId, parentUsers)}
                      isSearchable
                      isClearable
                      isDisabled={isDealer}
                      isLazyFrontend
                      lazyPageSize={50}
                      loading={loadingParentUser}
                    /> : null}
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={userOptions}
                    label="Ödemeyi Alan Kullanıcı"
                    name="createUserId"
                    type="select"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.createUserId}
                    touched={touched.createUserId}
                    defaultValue={values.createUserId}
                    value={getSelectedValueFromId(values.createUserId, userOptions)}
                    isSearchable
                    isClearable
                    isDisabled={isDealer}
                    isLazyFrontend
                    lazyPageSize={50}
                    loading={loadingUser}
                  />
                </div>
                <div className="mt-2">
                  {firmInformations.isCurrency === true ? <FormSelector
                    options={currencySelectList}
                    label="Para Birimi"
                    name="currencyId"
                    type="select"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.currencyId}
                    touched={touched.currencyId}
                    defaultValue={formValues.currencyId}
                    value={getSelectedValueFromId(values.currencyId, currencySelectList)}
                    isClearable
                  /> : ""}
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2 mr-0">
              {/* <div className="mr-3 mt-2">
                <FormCheckbox
                  label="Detay Göster"
                  name="showDetail"
                  id="showDetail"
                  type="checkbox"
                  onChange={setFieldValue}
                  value={values.showDetail}
                />
              </div> */}
              <Button
                type="button"
                color="gray"
                hover="gray"
                size="xs"
                className="mr-3"
                callback={clearFilters}
              >
                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                <span className='ml-3'>{buttonTexts.filterClear}</span>
              </Button>
              <Button type="submit" color="primary" hover="primary" size="xs">
                <img src="/icons/prepare-white.svg" alt="prepare" />
                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
              </Button>
            </div>
          </div>
          <div
            className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""
              }`}
          >
            <FormFiltersShortList
              formValues={{ ...values }}
              fields={fields}
              initialValues={initialValues}
              callback={(val) => onUpdate(val)}
              clearFilter={() => {
                clearFilters();
                submitform();
              }}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
})

export default Filters;